export default __webpack_public_path__ + "static/media/ic_audio.70e540eb.svg";